export const PRODUCER_CONFIG = '/api/ProducerConfig';

export const MESSAGES = {
  CREATED: 'Producer config created successfully!',
  PRODUCER_EXISTS: 'Producer Name already exists!',
  DELETED: 'Producer config deleted successfully!',
  CONFIRM_ACTIVE: 'Are you sure you want to Activate this producer config?',
  CONFIRM_INACTIVE: 'Are you sure you want to Inactivate this producer config?',
  UPDATED: 'Producer config details updated successfully!',
  REQUIRED_NAME: 'Producer Name is required!',
  REQUIRED_COUNTERPARTY: 'Counterparty is required!',
  REQUIRED_COUNTERPARTY_CODE: 'Counterparty Code is required!',
  REQUIRED_SUB_TERMINAL: 'Sub Terminal is required!',
};
